import React from 'react';
import { Product } from '../types';
import { useNavigate } from 'react-router-dom';
import styles from './ProductCard.module.css';

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.productCard}>
      <div className={styles.productImageContainer}>
        <img
          src={product.imageUrl}
          alt={product.name}
          className={styles.productImage}
          onClick={() => navigate(`/product/${product.id}`)}
        />
      </div>
      <h3
        className={styles.productName}
        onClick={() => navigate(`/product/${product.id}`)}
      >
        {product.name}
      </h3>
      <p className={styles.productPrice}>
        ${product.price.toFixed(2)}
      </p>
    </div>
  );
};

export default ProductCard;
